import { useShadow, useShadowStyle } from '../../../components/wcUtil.ts';
import '../../../components/base/buttons/as-button.ts';
import styleText from './as-modal-grabcad-success.css?raw';
import type { ExportStatusDetail } from '../../../data/data-interfaces.external.ts';

export class AsModalGrabcadSuccess extends HTMLElement {
  private _onExportStatus = (e: Event): void => {
    const detail = (e as CustomEvent<ExportStatusDetail>).detail;
    if (detail.operation === 'grabcad' && detail.state === 'success') {
      this._overlay()?.open(this.id);
    }
  };

  connectedCallback(): void {
    useShadow(this, /*html*/`
      <div class="modal-panel">
        <p class="message-main">Your design was transferred to GrabCAD Print and was placed on the build tray.</p>
        <p class="message-secondary">You can start the print preparation now after closing this app.</p>
        <p class="message-secondary">Please don't forget to save your project beforehand.</p>
        <div class="actions">
          <as-button name="cancel" default-text="Cancel"></as-button>
          <as-button name="close-app" default-text="Close"></as-button>
          <as-button name="save-and-close" default-text="Save and close"></as-button>
        </div>
      </div>
    `);
    useShadowStyle(this, styleText, './as-modal-grabcad-success.css');

    this.shadowRoot!.addEventListener('as-button-click', (e: Event) => {
      const name = (e as CustomEvent<{ buttonName: string | null }>).detail.buttonName;
      if (name === 'cancel') this._overlay()?.close();
      else if (name === 'close-app') window.dispatchEvent(new CustomEvent('as-close-app'));
      else if (name === 'save-and-close') window.dispatchEvent(new CustomEvent('as-close-app', { detail: { save: true } }));
    });

    window.addEventListener('as-export-status', this._onExportStatus);
  }

  disconnectedCallback(): void {
    window.removeEventListener('as-export-status', this._onExportStatus);
  }

  private _overlay(): any {
    return this.closest('as-modal-overlay') ?? document.querySelector('#as-app-overlay');
  }
}

if (!customElements.get('as-modal-grabcad-success')) {
  customElements.define('as-modal-grabcad-success', AsModalGrabcadSuccess);
}
